export default __webpack_public_path__ + "static/media/check.79e714c4.svg";